<template>
  <div class="custom-navi" style="padding-bottom: 70px;">
   
    <a-menu
      v-model:openKeys="openKeys"
      v-model:selectedKeys="selectedKeys"
      mode="inline"
    >
      <a-sub-menu v-for="items in NavDatas" :key="items.key">
        <template #title>{{items.title}}</template>
        <a-menu-item v-for="child in items.children" :key="child.key">
            <router-link :to="{ path: child.key}">
              {{child.title}}
            </router-link>
        </a-menu-item>
      </a-sub-menu>

    </a-menu>
  </div>
</template>
<script lang='ts' setup>
import { defineComponent, reactive, toRefs, watch, ref, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import {  
  UserStatusMap,
  UserRoleOperator,
  UserRoleDirectorManager,
  UserRoleDirector,
  UserRoleBlogger,
  UserRoleAuditor,
} from '@/utils/macro'

import NavDatas from './navs'



const isProd = ref(window.location.hostname=='marsadmin.marsvis.com')

const store = useStore()

const user_role = computed(() => store.state.user.role)

const router = useRouter()
const route = useRoute()

console.log('route.meta.key', route.meta.key);

const openKeys = ref([])
const selectedKeys = ref([])

// onMounted(() => {
//   selectedKeys.value = [route.path]
//   console.log('route', route);
  
//   openKeys.value = [route.meta.key]
//   console.log('openKeys.value', route.meta.key);
// })

// 监听路由变化
watch(() => route.path, (newRoute) => {
  selectedKeys.value = [newRoute]
  openKeys.value = [route.meta.key]
}, { immediate: true })

</script>
<style lang="scss">
.custom-navi {
  .navi-icon {
    width: 16px;
  }
  .ant-menu-light {
    color: $blackText;
    font-weight: 600;
    font-size: 14px;
  }
  .ant-menu-light.ant-menu-inline .ant-menu-sub.ant-menu-inline {
    font-weight: normal;
    background-color: #fff;
    color: $greyText;
  }
  .ant-menu-light .ant-menu-sub .ant-menu-item-selected {
    color: $mainColor;
    background: #fff;
    font-weight: 600;
    background: linear-gradient(90deg, rgba(39, 91, 255, 0.1) 0%, rgba(39, 91, 255, 0) 100%);
    border-radius: 16px 0 0 16px;

  }
  .ant-menu-light .ant-menu-submenu-selected >.ant-menu-submenu-title {
    color: $blackText;
    background: linear-gradient(90deg, rgba(39, 91, 255, 0.2) 0%, rgba(39, 91, 255, 0.08) 100%);
    border-radius: 0;
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      background-color: #4DA3FF;
      height: 100%;
      width: 4px;
    }
  }
  .ant-menu-light .ant-menu-item-selected {
    color: $blackText;
    background: linear-gradient(90deg, rgba(39, 91, 255, 0.15) 0%, rgba(39, 91, 255, 0.05) 100%);
    border-radius: 0;
  }
  .ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover,
  .ant-menu-light .ant-menu-submenu-title:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected) {
    background-color: rgba(0, 0, 0, 0.02);
  }

  .ant-menu-light.ant-menu-root.ant-menu-inline {
    border-right: unset;
  }

}
</style>